<template>
    <div class="login_body container-fluid">
        <div class="overlay" v-if="loading"></div>
        <div class="row justify-content-center align-items-center" style="height: 100vh;">
            <div class="col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                <div class="login_card">
                    <div class="lang-switch-container">
                        <button class="btn-lang" @click="langswap()" :title="langmode === 'ENG' ? 'Switch to Bahasa Malaysia' : 'Switch to English'">
                            <img v-if="langmode === 'ENG'" src="../assets/country_flags/en_US.svg" alt="English" class="flag-icon" />
                            <img v-else src="../assets/country_flags/ms_MY.svg" alt="Bahasa Malaysia" class="flag-icon" />
                            <span class="lang-code">{{ langmode }}</span>
                        </button>
                    </div>
                    <div class="text-center login-header">
                        <img src="../assets/ctrlytics-logo-black.png" alt="ctrlytics" class="brand-logo" />
                        <div class="pos-badge">POS</div>
                        <p class="title_text">{{ lang.title_text }}</p>
                    </div>
                    <form @submit.prevent="login">
                        <div class="form-group">
                            <label class="input_header_style" for="username">{{ lang.username }}</label>
                            <input type="text" class="form-control custom_input" id="username" :placeholder="lang.username_hint" v-model="username" required />
                        </div>
                        <div class="form-group" style="margin-top: 16px;">
                            <label class="input_header_style" for="password">{{ lang.password }}</label>
                            <input type="password" class="form-control custom_input" id="password" :placeholder="lang.password_hint" v-model="password" required />
                        </div>
                        <div class="text-center">
                            <button type="submit" class="login_btn">{{ lang.login_button }}</button>
                            <div v-if="tryagainWarning" class="warning-msg text-center">{{ lang.login_warning }}</div>
                        </div>
                    </form>
                    <div class="powered_by text-center">
                        <p>{{ lang.powered_by }}</p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import { resetSessionGuard } from '../api/sessionGuard'

export default{
    data(){
        return{
            username: '',
            password: '',
            loading: false,
            tryagainWarning: false,
            lang : [],
            langmode : "ENG"
        };
    },
    methods:{
        login(){
            console.log('Logging in with:', this.username, this.password);
            this.loading = true;
            if(this.username && this.password){
                const axios = require('axios');
                let data = JSON.stringify({
                    "username": this.username,
                    "password": this.password
                });
                let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: process.env.VUE_APP_BACKEND_URL+'/v1/login/pos',
                headers: {
                    "Authorization": `Bearer ${localStorage.bearer_token}`,
                    'Content-Type': 'application/json'
                },
                data : data
                };

                axios.request(config)
                .then((response) => {
                console.log(JSON.stringify(response.data));
                if (response.data["200"] != undefined){
                    console.log('Login Successful');
                    localStorage.token = response.data["200"]
                    localStorage.setItem('branch_codename', response.data["codename"])
                    localStorage.setItem('username', this.username)
                    localStorage.role = response.data["role"]
                    localStorage.isDemo = response.data["is_demo"]
                    localStorage.bearer_token = response.data["bearer_token"]
                    this.loading = false
                    this.tryagainWarning = false
                    // Re-arm the guard: this is an SPA, so after a sign-out it would otherwise
                    // stay disarmed for the rest of the page's life.
                    resetSessionGuard()
                    this.$router.replace({path:'/manage-devices'})
                }
                else{
                    this.loading = false
                    this.tryagainWarning = true
                }
                })
                .catch((error) => {
                console.log(error);
                this.loading = false
                this.tryagainWarning = true
                });
            }
            else if(!this.username){
                console.log('Please fill in username')
                this.loading = false
                this.tryagainWarning = false
            }
            else if(!this.password){
                console.log('Please fill in password')
                this.loading = false
                this.tryagainWarning = false
            }
            else{
                console.log('Login Error')
                this.loading = false
                this.tryagainWarning = true
            }
        },
        async langchange(val){
            this.langmode = val
            const response = await fetch("/login.json");
            const data = await response.json();
            this.lang = data[this.langmode]
        },
        langswap(){
            var langmode
            if (this.langmode === "ENG"){
                langmode = "BM"
            }
            else{
                langmode = "ENG"
            }
            this.langchange(langmode)
        }
    },
    mounted() {
        this.langchange("ENG");
        localStorage.clear();
    },
};
</script>

<style scoped>
@import '../fonts/fonts.css';


    .login_body{
        background-color: var(--primary-color);
        height: 100%;
        width: 100%;
        margin-top: 0px;
        z-index: 10;
        font-family: var(--font-family-base);
    }
    /* Premium white card floating on the yellow background */
    .login_card{
        position: relative;
        background-color: var(--surface-color);
        border-radius: var(--border-radius-xl);
        box-shadow: var(--shadow-premium);
        padding: 40px 36px;
        max-width: 440px;
        margin: 0 auto;
    }
    .login-header{
        margin-top: 8px;
        margin-bottom: 28px;
    }
    .brand-logo{
        max-width: 70%;
        max-height: 72px;
        height: auto;
        object-fit: contain;
    }
    /* "POS" sub-brand badge — same product family, POS entry point */
    .pos-badge{
        display: inline-block;
        margin-top: 14px;
        padding: 3px 14px;
        background-color: var(--text-main);
        color: var(--primary-color);
        font-family: var(--font-family-header);
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.18em;
        text-transform: uppercase;
        border-radius: 50px;
    }
    .title_text{
        font-weight: 500;
        font-size: var(--font-size-base);
        font-family: var(--font-family-base);
        color: var(--text-main);
        opacity: 0.8;
        margin-top: 10px;
        margin-bottom: 0;
    }
    /* Language switcher pill (top-right of card) */
    .lang-switch-container{
        position: absolute;
        top: 16px;
        right: 16px;
    }
    .btn-lang{
        display: flex;
        align-items: center;
        gap: 8px;
        background: transparent;
        border: 1px solid var(--border-color);
        border-radius: 20px;
        padding: 6px 12px;
        cursor: pointer;
        transition: all var(--transition-fast);
    }
    .btn-lang:hover{
        background-color: var(--background-color);
        transform: translateY(-1px);
    }
    .flag-icon{
        width: 20px;
        height: 15px;
        object-fit: cover;
        border-radius: 2px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
    .lang-code{
        font-size: 12px;
        font-weight: 600;
        color: var(--text-main);
    }
    .login_btn{
        text-align: center;
        margin-top: 28px;
        width: 100%;
        height: 46px;
        font-family: var(--font-family-base);
        font-size: 14px;
        font-weight: 700;
        border: none;
        border-radius: 50px;
        background-color: var(--text-main);
        color: var(--primary-color);
        letter-spacing: 0.5px;
        box-shadow: var(--shadow-sm);
        transition: transform var(--transition-fast), box-shadow var(--transition-fast), background-color var(--transition-fast);
        cursor: pointer;
    }
    .login_btn:hover{
        background-color: #000;
        transform: translateY(-2px);
        box-shadow: var(--shadow-md);
    }
    .input_header_style{
        display: block;
        font-family: var(--font-family-base);
        font-size: var(--font-size-sm);
        color: var(--text-main);
        font-weight: 600;
        margin-bottom: 6px;
    }
    .custom_input{
        background-color: var(--gray-50);
        height: 46px;
        width: 100%;
        border: 1px solid var(--gray-200) !important;
        border-radius: var(--border-radius-md);
        color: var(--text-main);
        letter-spacing: 0.131118px;
        font-size: 14px !important;
        box-sizing: border-box;
        transition: var(--transition-fast);
    }
    .custom_input:focus{
        outline: none !important;
        box-shadow: 0 0 0 4px var(--primary-glow) !important;
        border-color: var(--primary-color) !important;
        background-color: var(--surface-color);
        color: var(--text-main);
    }
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */
        z-index: 9998; /* Below the loading content */
    }
    .warning-msg {
        color: var(--error-text);
        font-weight: bold;
        font-size: 12px;
        margin-top: 12px;
    }
    .powered_by{
        margin-top: 28px;
    }
    .powered_by p{
        color: var(--text-muted);
        font-size: 12px;
        margin: 0;
    }
    ::placeholder{
        font-size: 13px;
        color: var(--gray-400);
    }
    @media(max-width: 480px){
        .login_card{
            padding: 28px 22px;
        }
        .img_style{
            max-width: 220px;
            height: 60px;
        }
    }
</style>